import lazyWithRetry from '../utils/lazyWithRetry';

const BidderAccountProfile = lazyWithRetry(() =>
	import('../pages/BidderPortal/BidderAccountProfile'),
);
const BidderInvitationRoute = lazyWithRetry(() =>
	import('../pages/BidderPortal/BidderInvitationRoute'),
);
const Signout = lazyWithRetry(() => import('../pages/SignOut'));

export default [
	{
		exact: true,
		name: 'Bidder Profile',
		path: '/bidder/profile',
		Component: BidderAccountProfile,
	},
	{
		exact: true,
		name: 'Bidder Invitation',
		path: '/bidder/invitations/:invitationId',
		Component: BidderInvitationRoute,
	},
	{
		exact: true,
		name: 'Bidder Signout',
		path: '/signout',
		Component: Signout,
	},
];
